import { WhiteLabelPortalEnums } from '@/common/enums/whiteLabelPortalEnums'

export const getWhiteLabelPortalName = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_NAME)
}

export const getWhiteLabelPortalLogo = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_LOGO)
}

export const getWhiteLabelPortalFavicon = () => {
  return (
    sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_FAVICON) ||
    sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_LOGO)
  )
}
export const getWhiteLabelPortalPrimaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_PRIMARY_COLOR)
}
export const getWhiteLabelPortalOnPrimaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_ON_PRIMARY_COLOR)
}
export const getWhiteLabelPortalSecondaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_SECONDARY_COLOR)
}
export const getWhiteLabelPortalOnSecondaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_ON_SECONDARY_COLOR)
}
export const getWhiteLabelPortalBackgroundColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_BACKGROUND_COLOR)
}
export const getWhiteLabelPortalOnBackgroundColor = () => {
  return sessionStorage.getItem(
    WhiteLabelPortalEnums.PORTAL_ON_BACKGROUND_COLOR,
  )
}

export const isBionicSite = () => {
  return (
    sessionStorage
      .getItem(WhiteLabelPortalEnums.PORTAL_DOMAIN)
      ?.includes('bionicwp.com') || false
  )
}
